import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import utils from "../assets/js/utils";
const Axios = axios.create({
   timeout: 30000,
   withCredentials: true,
   headers: {
      'content-type': "application/json;charset=UTF-8",
   }
})

let DEFAULT_LANG = 'en';
// if(window.localStorage.localeLanguage){
//    DEFAULT_LANG = window.localStorage.getItem('localeLanguage')
// }else{
//    let reg = new RegExp(/-/g);
//    if(window.location.href.toLowerCase().indexOf('lang'.toLowerCase())>-1){
//       DEFAULT_LANG = utils.GetQueryString('lang').replace(reg,'');
//    }else{
//       DEFAULT_LANG = 'en'
//    }
// }

/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
   let token =Vue.prototype.$cookies.get('user_session')
   if(token ==='null' || token ==='' || token === undefined){
      return
   }else{
      next();
   }
})

// 全局的http request 处理
Axios.interceptors.request.use(config => {
   let eventToken = Vue.prototype.$cookies.get('user_session')
   if(eventToken){
      let token = '?lang='+DEFAULT_LANG+'&jstoken=' + eventToken
      config.url = config.url + token
      config.headers['Authorization'] = 'Bearer' +" "+ eventToken
      config.data = Object.assign({}, config.data, {
      })
      // 请求参数添加时间戳防止缓存
      // if (config.method === 'get') {
      //    config.params = {
      //       ...config.params
      //    }
      // }
      if (config.method === 'post') {
         config.params = {
            ...config.params
         }
      }
      return config
   }
}, error => {
   return Promise.reject(error)
})

// 全局的http response 处理
Axios.interceptors.response.use(
   response => {
      if (response.status == 200) {
         return response.data
      } else {
         Promise.reject(error)
      }
   },
   error => {
      checkStatus(error.response)
      return Promise.reject(error)
   }
)

// http状态码错误处理
const checkStatus = (res) => {
   Vue.prototype.hideloading()
   switch (res.status)
   {
      case 400 :{
         Vue.prototype.dialog('Request error (400)')
         break;
      }
      case 401 :{
         new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_TOKEN + '/exchangjstoken/ac84bea68d759db0b32d7908e1ebbff7').then((res) => {
               if (res.data.jstoken) {
                  Vue.prototype.$cookies.set("user_session", res.data.jstoken, 60 * 60 * 1)
               }
               resolve(res)
            }).catch(error => {
               reject(error);
            });
         })
         Vue.prototype.dialog('Authorization failed, click ok to reauthorize.')
         break;
      }
      case 404 :{
         Vue.prototype.dialog('Request error (404)')
         break;
      }
      case 405 :{
         Vue.prototype.dialog('The request method is not allowed (405)')
         break;
      }
      case 408 :{
         Vue.prototype.dialog('Request timeout (408)')
         break;
      }
      case 504 :{
         Vue.prototype.dialog('Network timeout (504)')
         break;
      }
      default:
         Vue.prototype.dialog('Failed to connect server (500)')
         break;
   }
}

export default Axios